var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRealEstate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 16.5001V3.00014C31.4992 2.75822 31.44 2.5201 31.3272 2.30604C31.2146 2.092 31.0518 1.90837 30.8528 1.77085C30.6538 1.63333 30.4244 1.54598 30.1844 1.51625C29.9442 1.48652 29.7006 1.5153 29.474 1.60014L12.974 10.1401C12.6887 10.247 12.4427 10.4381 12.2687 10.6882C12.0947 10.9383 12.001 11.2355 12 11.5401V19.5001",
    stroke: "#001145",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 10.5H31.5",
    stroke: "#001145",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16.5H31.5",
    stroke: "#001145",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 25.5H6",
    stroke: "#001145",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 31.5H9",
    stroke: "#001145",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.31196V1.50195",
    stroke: "#001145",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 46.5V22.5C16.5 21.7044 16.1839 20.9412 15.6213 20.3786C15.0587 19.8161 14.2956 19.5 13.5 19.5H4.5C3.70436 19.5 2.94128 19.8161 2.37868 20.3786C1.81607 20.9412 1.5 21.7044 1.5 22.5V46.5H25.5",
    stroke: "#001145",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 22.5C39.887 22.5 42.1762 23.4482 43.864 25.136C45.5518 26.8238 46.5 29.113 46.5 31.5C46.5 35.342 41.124 42.8 38.682 45.924C38.5418 46.1036 38.3624 46.2488 38.1576 46.3486C37.9528 46.4486 37.7278 46.5004 37.5 46.5004C37.2722 46.5004 37.0472 46.4486 36.8424 46.3486C36.6376 46.2488 36.4582 46.1036 36.318 45.924C33.876 42.8 28.5 35.342 28.5 31.5C28.5 29.113 29.4482 26.8238 31.136 25.136C32.8238 23.4482 35.113 22.5 37.5 22.5Z",
    stroke: "#001145",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 32.25C37.0858 32.25 36.75 31.9142 36.75 31.5C36.75 31.0858 37.0858 30.75 37.5 30.75",
    stroke: "#001145",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 32.25C37.9142 32.25 38.25 31.9142 38.25 31.5C38.25 31.0858 37.9142 30.75 37.5 30.75",
    stroke: "#001145",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealEstate);
export default __webpack_public_path__ + "static/media/real_estate.e802b8c88b6289ffa75c71f54fa734f8.svg";
export { ForwardRef as ReactComponent };